import { useSanitizedRouteParams } from 'src/hooks/useSanitizedRouteParams';
import React from 'react';

import { ProtectedRoutes } from './ProtectedRoutes';

interface ConditionalProtectedRoutesProps {
  requiredPermissions?: string[];
  children: React.ReactNode;
  unprotectedTabs?: string[];
}

export const ConditionalProtectedRoutes: React.FC<ConditionalProtectedRoutesProps> = ({
  requiredPermissions,
  children,
  unprotectedTabs = ['status'],
}) => {
  const { tab } = useSanitizedRouteParams();

  // If the current tab is in the unprotected tabs list, render children without protection
  if (tab && unprotectedTabs.includes(tab)) {
    return <>{children}</>;
  }

  // Otherwise, apply protection
  return <ProtectedRoutes requiredPermissions={requiredPermissions}>{children}</ProtectedRoutes>;
};
